import { LicenseInfo } from '@mui/x-license';
import { env } from 'core/config';

LicenseInfo.setLicenseKey(env.MUI_LICENSE_KEY);

export default function MuiXLicense() {
  return null;
}
